module.exports = __webpack_public_path__ + "images/slobodnadomena-logo-red-88c567f5742996ccc27c839f840e6afe.svg";


//////////////////
// WEBPACK FOOTER
// ./app/frontend/images/slobodnadomena-logo-red.svg
// module id = 3
// module chunks = 0